module.exports = __webpack_public_path__ + "img/13.563a5e3b.png";